import { LocalizedLinkConfig } from '@next/core-lib/i18n';

export const linkConfig: LocalizedLinkConfig = {
  generalTermsAndConditions: {
    NL10: {
      defaultLanguage: 'nl',
      languages: {
        nl: 'https://www.agrifirm.nl/globalassets/agrifirm-group/agrifirm-nl/leveringsvoorwaarden/general-terms--nl.pdf',
      },
    },
    BE10: {
      defaultLanguage: 'nl',
      languages: {
        nl: 'https://www.agrifirm.be/footer---filter-items/algemene-leveringsvoorwaarden/',
      },
    },
    PL10: {
      defaultLanguage: 'pl',
      languages: {
        pl: 'https://www.agrifirm.pl/globalassets/agrifirm-group/agrifirm-pl/pliki/ows/owz-agrifirm-2021-ab1.pdf',
      },
    },
    DE10: {
      defaultLanguage: 'de',
      languages: {
        de: 'https://www.agrifirm.de/footer-items/allgemeine-lieferbedingungen/',
      },
    },
  },
  deliveryConditionsRumimants: {
    NL10: {
      defaultLanguage: 'nl',
      languages: {
        nl: '/assets/documents/terms-and-conditions/delivery-conditions-ruminants.nl.pdf',
      },
    },
    DE10: {
      defaultLanguage: 'de',
      languages: {
        de: '/assets/documents/terms-and-conditions/delivery-conditions-ruminants.de.pdf',
      },
    },
  },
  deliveryConditionsPoultry: {
    NL10: {
      defaultLanguage: 'nl',
      languages: {
        nl: '/assets/documents/terms-and-conditions/delivery-conditions-poultry.nl.pdf',
      },
    },
    DE10: {
      defaultLanguage: 'de',
      languages: {
        de: '/assets/documents/terms-and-conditions/delivery-conditions-poultry.de.pdf',
      },
    },
  },
  deliveryConditionsPigs: {
    NL10: {
      defaultLanguage: 'nl',
      languages: {
        nl: '/assets/documents/terms-and-conditions/delivery-conditions-pigs.nl.pdf',
      },
    },
    DE10: {
      defaultLanguage: 'de',
      languages: {
        de: '/assets/documents/terms-and-conditions/delivery-conditions-pigs.de.pdf',
      },
    },
  },
  deliveryConditionsPlant: {
    NL10: {
      defaultLanguage: 'nl',
      languages: {
        nl: '/assets/documents/terms-and-conditions/delivery-conditions-fertilizers-crop-protection-seeds-supplies.nl.pdf',
      },
    },
  },
  belgiumContactAndLocations: {
    BE10: {
      defaultLanguage: 'nl',
      languages: {
        nl: 'https://www.agrifirm.be/over-ons/contact--locaties/',
      },
    },
  },

  siloSticker: {
    NL10: {
      defaultLanguage: 'nl',
      languages: {
        nl: 'https://www.agrifirm.nl/aanbod/silostickers/',
      },
    },
  },
};
